<template>
  <custom-modal
    class="custom-modal__extended"
    id="rate-modal"
    ref="rateModalRef"
    v-b-modal.modal-center
    :title="$t('SatisfactionSurvey')"
    @accept="() => {}"
  >
    <div class="py-2 px-2 font-14 border-bottom">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <p class="color-black-1 font-16 mt-3 text-center">
          {{ $t('RateYourExperienceSubmittingApplication') }}
        </p>
        <star-rating
          class="mb-3"
          v-model="model.value"
          animated
          :show-rating="false"
          :star-size="40"
        />
      </div>
    </div>
    <template #footer>
      <div class="d-flex align-items-center justify-content-center pb-3">
        <action-button
          class="warning outline-warning px-4 py-2 mr-3"
          :text="$t('btCancel.Text')"
          i="fa fa-times-circle"
          @click="$emit('close')"
        />
        <action-button
          class="btn-success px-4 py-2"
          :text="$t('btnSaveConfirm.Text') | capitalize"
          i="far fa-check-circle"
          @click="$emit('accept')"
        />
      </div>
    </template>
  </custom-modal>
</template>

<script>
//libs
import StarRating from 'vue-star-rating';
import ActionButton from 'ActionButton';

//common components
import { CustomModal } from '@/components/common';

export default {
  name: 'RatingModal',
  components: {
    StarRating,
    ActionButton,
    CustomModal,
  },
  data: () => ({
    model: {
      value: null,
    },
  }),
  methods: {
    showModal() {
      this.$refs.rateModalRef.showModal();
    },
    hideModal() {
      this.$refs.rateModalRef.hideModal();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';

.custom-modal__extended {
  ::v-deep .modal-dialog {
    max-width: 500px !important;
  }
}
</style>
